import React from "react";
// react plugin that creates an input with badges
import {globals,award_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalAward } from '../../redux/modalSlice'; 
import { updateAward, addAward } from '../../redux/awardSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const AwardFormDialog = () => {
  const {awardModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("awardModal -> ",awardModal);
    console.log("awardModal.activeObject -> ",awardModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalAward())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {awardModal.activeObject &&
              <h1>{awardModal.activeObject.data_blob.data_tier.award_hotel_name}</h1>}
              {awardModal.activeObject===null &&
              <h1>{"<Nouvel hotel du mois>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {award_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_awards_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Hotel du mois enregistré"})); console.log("AwardFormDialog::saved_data ->",saved_data);dispatch(addAward(saved_data)); dispatch(closeModalAward());}}
                //Let us update the articl
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Hotel du mois modifié"})); console.log("AwardFormDialog::updated_data ->",updated_data); dispatch(updateAward(updated_data)); dispatch(closeModalAward());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde de l'hôtel du mois"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalAward())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {awardModal.activeObject}
                data_blob = {awardModal.activeObject?awardModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {awardModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default AwardFormDialog;
